import React from 'react';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/form.module';

export const RoutePointBasicInfoComponent = ({ routes,rapAgents, onInnerBasicFormChange, selectedRoutePoints }: any) => (

    <><AccordionContainer
        child={
            <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
              
            
                <InputContainer

                    label="Route"
                    labelField="MobilityRouteName"
                    list={routes}
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'MobilityRouteId'
                                
                        );
                    }}
                    optionName='Choose Route'
                    type="select"
                    value={selectedRoutePoints?.MobilityRouteId}
                    valueField="Id"
                />
                     <InputContainer
                    label="Location Name"
                    name="LocationName"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'LocationName'
                        )
                    }}
                    type="text"
                    value={selectedRoutePoints?.LocationName}
                />
                <InputContainer
                    label="Remarks"
                    name="Remarks"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'Remarks'
                        )
                    }}
                    type="text"
                    value={selectedRoutePoints?.Remarks}
                />
                <InputContainer
                    label="Rap Agent"
                    labelField="Name"
                    list={rapAgents}
                    onValueChange={(newValue: any) => {
                        const transportAgentData: any = newValue.map((option: any) => option?.value || '')
                        onInnerBasicFormChange(
                            transportAgentData,
                            'RAPAgentIds'
                        )
                    }}
                    type="multiselect"
                    valueField="Id"
                    value={selectedRoutePoints?.RAPAgentIds}
                />

            </div>
        }
        expandedPanel="Basic Info"
        headerTitle="Basic Info"
    />
    </>

)
export default RoutePointBasicInfoComponent;
